import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { routes } from "./Routes";
import AppLayout from "../Layout/Layout";
import { isAuthenticated } from "../api/client";
import { getStoredUser } from "../api/auth";
import { getActiveLayoutSlug } from "../constants/layout";
import { roleHomePath } from "../constants/menuAccess";

const LayoutRoutes = () => {
  const fallback = isAuthenticated()
    ? roleHomePath(getStoredUser(), getActiveLayoutSlug())
    : "/login";

  return (
    <Routes>
      <Route element={<AppLayout />}>
        {routes.map(({ path, Component }, i) => (
          <Route key={path || i} path={path} element={Component} />
        ))}
      </Route>
      <Route path="*" element={<Navigate replace to={fallback} />} />
    </Routes>
  );
};

export default LayoutRoutes;
